import type {ReactElement} from 'react';
import {AiWriter} from '@Components/ai-writer';
import {AiWriterType} from '@Components/ai-writer/ai-writer.types';
import {useAiVoiceWriter} from '@Components/ai-writer/adapters/use-ai-voice-writer';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';
import type {AiWriterPopoverViewProps} from './ai-writer-popover-view.types';

export function AiWriterPopoverView({isOpen, referenceElementRef, onClose, onContentSelected}: AiWriterPopoverViewProps): ReactElement {
  const source = useAiVoiceWriter({onContentSelected});

  return (
    <AiWriter
      displayType={AiWriterType.POPOVER}
      source={source}
      alignment={PopoverDefaultAlignment.BOTTOM_START}
      referenceElementRef={referenceElementRef}
      isOpen={isOpen}
      onClose={onClose}
      closeOnItemSelect
    />
  );
}
